import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { alpha } from '@mui/material/styles';

AlertBanner.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  icon: PropTypes.node,
  color: PropTypes.string,
  onClick: PropTypes.func,
};

export default function AlertBanner({
  title,
  subtitle,
  color = 'grey',
  icon = <ErrorOutlineIcon fontSize="small" sx={{ color: (theme) => theme.palette.grey[700] }} />,
  onClick,
}) {
  return (
    <Box
      onClick={onClick}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'flex-start',
        padding: '9px 14px',
        gap: '4px',
        background: (theme) =>
          color === 'grey'
            ? theme.palette.grey[200]
            : alpha(theme.palette[color]?.main || theme.palette.grey[700], 0.08),
        borderLeft: (theme) =>
          `3px solid ${
            color === 'grey' ? theme.palette.grey[700] : theme.palette[color]?.dark || theme.palette.grey[700]
          }`,
        borderRadius: '8px',
        cursor: onClick ? 'pointer' : 'default',
        '&:hover': onClick
          ? {
              background: (theme) =>
                color === 'grey'
                  ? theme.palette.grey[300]
                  : alpha(theme.palette[color]?.main || theme.palette.grey[700], 0.12),
            }
          : {},
      }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start', gap: '6px' }}>
        {icon}
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
          <Typography
            sx={{
              fontSize: '11px',
              color: (theme) => (color === 'grey' ? theme.palette.grey[700] : theme.palette[color]?.dark),
            }}
          >
            {title}
          </Typography>
          {subtitle && (
            <Typography
              sx={{
                fontSize: '10px',
                color: (theme) => (color === 'grey' ? theme.palette.grey[500] : theme.palette[color]?.dark),
              }}
            >
              {subtitle}
            </Typography>
          )}
        </Box>
      </Box>
    </Box>
  );
}
